const RowPlaceholder = () => (
  <div className="mx-1 py-2 mb-3 grid grid-cols-[1rem_auto_1.75rem] gap-3">
    <div className="rounded-sm bg-gradient-to-r from-background to-secondary w-4 h-4" />
    <div className="rounded-sm bg-gradient-to-r from-background to-secondary w-full" />
  </div>
);

export default RowPlaceholder;
